import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './ProtectedRoute.module.css';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { member, loading } = useAuth();

  if (loading) {
    return (
      <div className={styles.loaderWrap}>
        <div className={styles.spinner} />
      </div>
    );
  }

  if (!member) {
    return <Navigate to="/members" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
